import { NgZone } from '@angular/core';
import { asyncScheduler } from 'rxjs';

import { environment } from '../../environments/environment';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { ɵZoneScheduler, ɵAngularFireSchedulers } from '@angular/fire';

function createSchedulers(zone: NgZone): ɵAngularFireSchedulers {
  const schedulers = Object.create(ɵAngularFireSchedulers.prototype) as ɵAngularFireSchedulers;
  (schedulers as any).outsideAngular = zone.runOutsideAngular(
    () => new ɵZoneScheduler(typeof (globalThis as any)['Zone'] === 'undefined' ? undefined : (globalThis as any)['Zone'].current)
  );
  (schedulers as any).insideAngular = zone.run(
    () => new ɵZoneScheduler(typeof (globalThis as any)['Zone'] === 'undefined' ? undefined : (globalThis as any)['Zone'].current, asyncScheduler)
  );
  return schedulers;
}

export function AngularFirestoreAuth(platformId: NonNullable<unknown>, zone: NgZone) {
  const currentConfig =
    environment.production === 'true'
      ? environment.firebaseAuthConfigProd
      : environment.firebaseAuthConfigDev;
  const schedulers = createSchedulers(zone);
  return new AngularFireAuth(
    currentConfig,
    'auth',
    platformId,
    zone,
    schedulers,
    null,
    null,
    null,
    null,
    null,
    null,
    null
  );
}

export function AngularFirestoreAttendance(platformId: NonNullable<unknown>, zone: NgZone) {
  const currentConfig =
    environment.production === 'true'
      ? environment.firebaseAttendanceConfigProd
      : environment.firebaseAttendanceConfigDev;
  const schedulers = createSchedulers(zone);
  return new AngularFireDatabase(
    currentConfig,
    'attendance',
    null,
    platformId,
    zone,
    schedulers,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null
  );
}
